"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const StatisticsBox_1 = __importDefault(require("./StatisticsBox"));
require("./StatisticsRow.scss");
const StatisticsRow = ({ className, boxes }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('donation-stats-row', className), children: boxes.map((box, index) => ((0, jsx_runtime_1.jsx)(StatisticsBox_1.default, Object.assign({}, box), index))) }));
};
exports.default = StatisticsRow;
